import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  Packages,
  SetVideoToAnotherGroupError,
  SetVideoToAnotherGroupInput,
  VideoDetailProps,
} from "../store/actionType";
import { connect, useSelector } from "react-redux";
import { resetVideo, setVideoToAnotherGroup } from "../store/action";
import { ApiError } from "components";
import SetVideoForm from "./components/SetVideoForm";
interface OwnProps {
  videoPackages: Packages[];
  videoData: VideoDetailProps;
  closeModal: () => void;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleSetVideoToAnotherGroup: React.FC<Props> = ({
  videoPackages,
  videoData,
  closeModal,
  onSetVideoToOtherGroup,
  // onResetVideo,
}) => {
  const videoDetailsState = useSelector(
    (state: any) => state.videoDetails
  );

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<SetVideoToAnotherGroupInput>({});
  const [error, setError] = useState<SetVideoToAnotherGroupError>({});
  const [apiError, setApiError] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    const newErrors: SetVideoToAnotherGroupError = {};

    if (!formData?.group_id || formData.group_id.length === 0) {
      newErrors.group_id = "Please select a group";
    }
    if (!formData?.category_id || formData.category_id.length === 0) {
      newErrors.category_id = "Please select a category";
    }
    if (!formData?.series_id || formData.series_id.length === 0) {
      newErrors.series_id = "Please select a series";
    }
    if (!formData?.season_id || formData.season_id.length === 0) {
      newErrors.season_id = "Please select a season";
    }
    if (!formData?.episode_id || formData.episode_id.length === 0) {
      newErrors.episode_id = "Please select an episode";
    }
    if (!formData?.title || formData.title.length === 0) {
      newErrors.title = "Please enter a title";
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return;
    }
    setError({});
    setLoading(true);
    setSubmitted(true);
    var input: SetVideoToAnotherGroupInput = {
      category_id: formData?.category_id,
      episode_id: formData?.episode_id,
      season_folder_id: formData?.season_id,
      title: formData?.title,
    };
    await onSetVideoToOtherGroup(input, videoData?.id.toString());
    setLoading(false);
    closeModal();
  };
  useEffect(() => {
    if (!videoDetailsState.isLoading && submitted) {
      if (videoDetailsState.error) {
        setApiError(videoDetailsState.error); // show error
      } else {
        setApiError(null);
        closeModal();
      }
    }
  }, [videoDetailsState.isLoading, videoDetailsState.error, submitted]);
  return (
    <div>
      <SetVideoForm
        onClose={closeModal}
        loading={loading}
        // header={`${videoPackages?.length > 0 ? "Update" : "Add"} Package to Video`}
        header={"Set Video to Another Group"}
        formData={formData}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSave} />
      {apiError && <ApiError>{apiError}</ApiError>}
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onSetVideoToOtherGroup: (input: SetVideoToAnotherGroupInput, video_id: string) =>
    dispatch(setVideoToAnotherGroup(input, video_id)),
  // onResetVideo: () => dispatch(resetVideo()),
});

export default connect(null, mapDispatchToProps)(HandleSetVideoToAnotherGroup);
